// Order bumps v1 sell one-time prices only (decided 6 Oct 2026). The recurring
// bump code is kept, and this one switch keeps it unreachable: it gates the
// offer resolvers (API and storefront), the bump product shape guard and the
// dashboard create form.
export const RECURRING_ORDER_BUMPS_ENABLED = false;
